import { render, staticRenderFns } from "./SidebarKills.vue?vue&type=template&id=2f9143fe&scoped=true&"
import script from "./SidebarKills.vue?vue&type=script&lang=js&"
export * from "./SidebarKills.vue?vue&type=script&lang=js&"
import style0 from "./SidebarKills.vue?vue&type=style&index=0&id=2f9143fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9143fe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VBtn,VDivider,VTextField})
